import styled from 'styled-components';
import { Card as MewsUiCard } from '@optimus-web/core';

export const Card = styled(MewsUiCard)<{ relative?: boolean }>`
    ${(props) => (props.relative ? 'position: relative;' : '')}
`;

Card.defaultProps = {
    padding: '200',
};
